<template>
    <div
        :class="`template-item ${theme}`"
        @click.stop
    >
        <span class="title">{{item.name}}</span>
        <p class="btns-group">
             <span
                 class="btn cancel"
                 @click="handlerPreview"
             >预览</span>
            <span
                class="btn cancel"
                @click="onSelect"
            >使用</span>
        </p>
    </div>
</template>

<script>
    import Config from '../../../../../../../../../../config/app'
    export default {
        name: "template-item",
        props: {
            item: Object,
            is_shop: {
                type: Boolean,
                default: false
            },
            isPlat: {
                type: Boolean,
                default: false
            },
            theme: String
        },
        methods: {
            handlerPreview(){
                const {clients_id, category_id, id} = this.item
                let obj = {
                    scene:'preview',
                    platform:'vue',
                    school_id: clients_id,
                    category_id,
                    is_template: true,
                    id,
                    is_shop: this.is_shop
                }
                let str = ''
                for(let item in obj){
                    str+= `&${item}=${obj[item]}`
                }
                window.open(`${Config.imeditPreview}?${str}`)
            },
            onSelect(){
                this.$emit('onSelect')
            }
        }
    }
</script>

<style lang="scss" scoped>
.template-item{
    width: calc(100% - 2px);
    height: 98px;
    background: #393B42;
    border-radius: 4px;
    border: 1px solid #656773;
    display: flex;
    flex-direction: column;
    justify-content: space-between;

    &.light{
        background: #FFFFFF;
        box-shadow: 0px 0px 2px 0px rgba(0, 0, 0, 0.1);
        border-radius: 4px;
        border: 1px solid #DCDFE6;
        border-width: 0px;

        .title{
            color: #303133;;
        }

        .btns-group {
            .btn{
                color: #606266;
                background: #FFFFFF;
                border-radius: 4px;
                border: 1px solid #DCDFE6;

                &:hover{
                    background: #26282E;
                    color: white;
                }
            }
        }
    }

    .title{
        display: inline-block;
        height: 20px;
        width: 200px;
        font-size: 14px;
        font-weight: 500;
        color: #FFFFFF;
        line-height: 20px;
        overflow-x: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        margin: 14px 16px;
    }

    .btns-group{
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        align-items: center;
        margin-bottom: 14px;

        .btn{
            width: 60px;
            height: 28px;
            font-size: 14px;
            text-align: center;
            line-height: 28px;
            color: #BDBEC7;
            background: #5C606B;
            border-radius: 4px;
            margin-left: 0px;
            margin-right: 12px;
            cursor: pointer;
            transition: all .3s linear;

            &:hover{
                background-color: #724B3C;
            }
        }
    }
}
</style>
